import React from 'react';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import SelectBox from '../../../../components/common/selectBox/SelectBox';
import Calendar from '../../../../components/searchBox/calendar/Calendar';
import TypeOfFlight from '../../../../components/searchBox/typeOfFlight/TypeOfFlight';
import FlightAutocomplete from '../../../../components/searchBox/flightAutocomplete/FlightAutocomplete';

import { Col, Row } from 'react-bootstrap';
import Button from '../../../../components/button/Button';

const propTypes = {
  flightOrigin: PropTypes.string.isRequired,
  flightDestination: PropTypes.any.isRequired,
  flightBackOrigin: PropTypes.any.isRequired,
  flightBackDestination: PropTypes.any,
  flightDestiny: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  setFlightOrigin: PropTypes.func.isRequired,
  setFlightDestiny: PropTypes.func.isRequired,
  setFlightBackOrigin: PropTypes.func.isRequired,
  setFlightBackDestiny: PropTypes.func.isRequired,
  setTypeOfFlight: PropTypes.func.isRequired,
  handlerFocusStartDate: PropTypes.func.isRequired,
  handlerStartDate: PropTypes.func.isRequired,
  handlerEndDate: PropTypes.func.isRequired,
  changeValue: PropTypes.func.isRequired,
  handleAirportSearch: PropTypes.func.isRequired,
  minSelectionDate: PropTypes.string.isRequired,
  maxSelectionDate: PropTypes.string.isRequired,
  selectCabinCategory: PropTypes.string.isRequired,
  typeOfFlight: PropTypes.string.isRequired,
  economyLabel: PropTypes.string.isRequired,
  businessLabel: PropTypes.string.isRequired,
  handleProceed: PropTypes.any,
  isSelectedDestiny: PropTypes.bool,
  isSelectedOrigin: PropTypes.bool
};

class FlightChangeContainer extends React.Component {
  render() {
    const {
      flightOrigin,
      flightDestiny,
      flightBackOrigin,
      flightBackDestination,
      startDate,
      endDate,
      economyLabel,
      businessLabel,
      isSelectedOrigin,
      isSelectedDestiny
    } = this.props;

    let allDataInputed = economyLabel && businessLabel;

    if (isSelectedOrigin !== isSelectedDestiny) {
      allDataInputed = allDataInputed && flightOrigin && flightDestiny && startDate;
    } else {
      allDataInputed = allDataInputed && flightOrigin && flightDestiny && startDate && flightBackOrigin && flightBackDestination && endDate;
    }

    if (isSelectedDestiny) {
    }

    return (
      <div>
        <Row>
          <Col md={6}>
            <div data-unit="title" className="title margin-top-text text-400">
              {i18n.translate('title.flightChangeForm').toString()}
            </div>
          </Col>
        </Row>

        {isSelectedOrigin ? (
          <div>
            <div data-unit="text" className="title margin-top-text text-400">
              {i18n.translate('label.oneWayFlight').toString()}
            </div>
            <div className="row-flight">
              <div className="first-column-flight">
                <FlightAutocomplete
                  value={this.props.flightOrigin}
                  id="autocompleteFlightOrigin"
                  placeholder={i18n.translate('placeholder.flightOrigin')}
                  title={i18n.translate('label.titleFlightOrigin')}
                  callBack={this.props.setFlightOrigin}
                  searchAirport={searchTerm =>
                    this.props.handleAirportSearch(searchTerm, this.props.flightDestiny)
                  }
                />
              </div>
              <div className="azul-icon-airplane" />
              <div className="last-column-flight">
                <FlightAutocomplete
                  value={this.props.flightDestiny}
                  id="autocompleteFlightDestination"
                  placeholder={i18n.translate('placeholder.flightDestination')}
                  title={i18n.translate('label.titleFlightDestination')}
                  searchAirport={searchTerm =>
                    this.props.handleAirportSearch(searchTerm, this.props.flightOrigin)
                  }
                  callBack={this.props.setFlightDestiny}
                  ref={e => (this.flightDestination = e)}
                />
              </div>
            </div>
          </div>
        ) : null}

        {isSelectedDestiny ? (
          <div>
            <div data-unit="text" className="title margin-top-text padding-eight-top-32 text-400">
              {i18n.translate('label.flightBack').toString()}
            </div>
            <div className="row-flight">
              <div className="first-column-flight">
                <FlightAutocomplete
                  value={this.props.flightBackOrigin}
                  id="autocompleteFlightBackOrigin"
                  placeholder={i18n.translate('placeholder.flightOrigin')}
                  title={i18n.translate('label.titleFlightOrigin')}
                  searchAirport={searchTerm =>
                    this.props.handleAirportSearch(searchTerm, this.props.flightBackDestination)
                  }
                  callBack={this.props.setFlightBackOrigin}
                  // eslint-disable-next-line no-return-assign
                  ref={e => (this.flightBackOrigin = e)}
                />
              </div>
              <div className="azul-icon-airplane" />
              <div className="last-column-flight">
                <FlightAutocomplete
                  value={this.props.flightBackDestination}
                  id="autocompleteFlightBackDestination"
                  placeholder={i18n.translate('placeholder.flightDestination')}
                  title={i18n.translate('label.titleFlightDestination')}
                  searchAirport={searchTerm =>
                    this.props.handleAirportSearch(searchTerm, this.props.flightBackOrigin)
                  }
                  callBack={this.props.setFlightBackDestiny}
                  // eslint-disable-next-line no-return-assign
                  ref={e => (this.flightBackDestination = e)}
                />
              </div>
            </div>
          </div>
        ) : null}

        <div data-unit="text" className="title margin-top-text padding-eight-top-32 text-400">
          {i18n.translate('label.flightDate').toString()}
        </div>
        {isSelectedDestiny !== isSelectedOrigin ? (
          <div className="row-calendar">
            <div className="first-column-calendar">
              {isSelectedOrigin ? (
                <Calendar
                  id="calendarStartDate"
                  placeholder={i18n.translate('placeholder.selectDate')}
                  title={i18n.translate('label.titleStartDate')}
                  onFocus={this.props.handlerFocusStartDate}
                  onChange={this.props.handlerStartDate}
                  value={this.props.startDate}
                  minDate={this.props.minSelectionDate}
                  maxDate={this.props.maxSelectionDate}
                  // eslint-disable-next-line no-return-assign
                  ref={e => (this.startDate = e)}
                />
              ) : (
                <Calendar
                  id="calendarEndDate"
                  placeholder={i18n.translate('placeholder.selectDate')}
                  title={i18n.translate('label.titleEndDate')}
                  onChange={this.props.handlerEndDate}
                  value={this.props.endDate}
                  minDate={this.props.startDate || this.props.minSelectionDate}
                  maxDate={this.props.maxSelectionDate}
                  // eslint-disable-next-line no-return-assign
                  ref={e => (this.endDate = e)}
                />
              )}
            </div>
            <div className="last-column-calendar"> </div>
          </div>
        ) : (
          <div className="row-calendar">
            <div className="first-column-calendar">
              <Calendar
                id="calendarStartDate"
                placeholder={i18n.translate('placeholder.selectDate')}
                title={i18n.translate('label.titleStartDate')}
                onFocus={this.props.handlerFocusStartDate}
                onChange={this.props.handlerStartDate}
                value={this.props.startDate}
                minDate={this.props.minSelectionDate}
                maxDate={this.props.maxSelectionDate}
                // eslint-disable-next-line no-return-assign
                ref={e => (this.startDate = e)}
              />
            </div>
            <div className="last-column-calendar">
              <Calendar
                id="calendarEndDate"
                placeholder={i18n.translate('placeholder.selectDate')}
                title={i18n.translate('label.titleEndDate')}
                onChange={this.props.handlerEndDate}
                value={this.props.endDate}
                minDate={this.props.startDate || this.props.minSelectionDate}
                maxDate={this.props.maxSelectionDate}
                // eslint-disable-next-line no-return-assign
                ref={e => (this.endDate = e)}
              />
            </div>
          </div>
        )}

        <div className="row-infos">
          <div className="first-column-infos">
            <SelectBox
              id="CabinCategory"
              label="label.cabinCategory"
              required={false}
              default={this.props.selectCabinCategory}
              values={[this.props.economyLabel, this.props.businessLabel]}
              changeValue={this.props.changeValue}
            />
          </div>
          <div className="last-column-infos">
            <TypeOfFlight
              typeOfFlight={this.props.typeOfFlight}
              typeOfFlightCallback={this.props.setTypeOfFlight}
            />
          </div>
        </div>
        <Row>
          <Col md={12}>
            <div className="warning">
              <span>
                Atenção! Pode ter diferença nos valores de acordo com as datas escolhidas.
              </span>
            </div>
          </Col>
        </Row>
        <div className="row-buttom-submit">
          <div className="buttom-submit-container">
            <Button
              name="flightChangeButton"
              onClick={() => this.props.handleProceed()}
              disabled={!allDataInputed}
              background={'navy-blue'}
              className="text-xl margin-eight-right-24">
              {i18n.translate('label.searchTickets').toString()}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

FlightChangeContainer.propTypes = propTypes;

export default FlightChangeContainer;



// WEBPACK FOOTER //
// ./src/page/flightChange/components/FlightChangeContainer/index.jsx